module.exports = __webpack_public_path__ + "static/front-page-07-60c31ade42e8599702f32a1cbb56971e.jpg";